import React, {useEffect, useRef, useState} from 'react';
import {cn, isMobileDevice} from '../../../utils/utils';
import {useSelector} from 'react-redux';
import users from '../../users';
import './titlePage.css';

function TitlePage({
                       icon,
                       title,
                       rightOptions,
                       titleClass,
                       leftClass,
                       rightClass,
                       disableScroll,
                       hideSeparator,
                       fixedHeight,
                       className,
                       style
                   }) {
    const darkMode = useSelector(users.selectors.isDarkMode);
    const titleRef = useRef(null);
    const containerRef = useRef(null);
    const [shouldScroll, setShouldScroll] = useState(false);

    useEffect(() => {
        const titleEl = titleRef.current;
        const containerEl = containerRef.current;
        if (titleEl && containerEl) {
            setShouldScroll(titleEl.scrollWidth > containerEl.clientWidth && !disableScroll);
        }
    }, [disableScroll, title]);

    return (
        <div style={{fontSize: 'large', fontWeight: '500', ...style}} className={cn('col-12', titleClass, className)}>
            <div
                className="col-12 d-flex flex-row justify-content-between align-items-center"
                style={{height: fixedHeight ?? (isMobileDevice() ? '1rem' : '1.8rem')}}
            >
                <div
                    ref={containerRef}
                    className={(leftClass ?? 'col-6') + (darkMode ? ' text-light' : ' text-dark') + ' d-flex flex-row align-items-center title-page__right-options'}
                    style={{
                        whiteSpace: 'nowrap',
                        overflow: shouldScroll ? 'hidden' : 'visible',
                        position: 'relative'
                    }}
                >
                    {icon && (
                        <>
                            <i className={icon}/> &nbsp;
                        </>
                    )}
                    <div style={{
                        overflow: shouldScroll ? 'hidden' : 'visible',
                        position: 'relative',
                        width: '100%',
                    }}>
                        <div
                            ref={titleRef}
                            className={shouldScroll ? 'scrolling-text' : ''}
                            style={{
                                display: 'inline-block',
                                minWidth: '100%',
                                whiteSpace: disableScroll ? 'break-spaces' : 'nowrap'
                            }}
                        >
                            {title}
                        </div>
                    </div>
                </div>
                {rightOptions && (
                    <div
                        className={(rightClass ?? 'col-6') + ' d-flex justify-content-end'}
                        style={{fontSize: 'normal', fontWeight: 'normal'}}
                    >
                        {rightOptions}
                    </div>
                )}
            </div>
            {!hideSeparator && <hr/>}
        </div>
    );
}

export default TitlePage;
